import { FlexColumn } from '@editor/components/utilities/layouts';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Card = styled(FlexColumn)`
  border: 1px solid ${themeStyle.inkBase}1A;
  background-color: ${themeStyle.inkBase}1A;
  border-radius: ${themeStyle.radiusMedium};

  padding: 20px;
  gap: 8px;
`;
